import { render, staticRenderFns } from "./InviteUser.vue?vue&type=template&id=340adc1a&"
import script from "./InviteUser.vue?vue&type=script&lang=js&"
export * from "./InviteUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('340adc1a')) {
      api.createRecord('340adc1a', component.options)
    } else {
      api.reload('340adc1a', component.options)
    }
    module.hot.accept("./InviteUser.vue?vue&type=template&id=340adc1a&", function () {
      api.rerender('340adc1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/onboarding/components/InviteUser.vue"
export default component.exports